import React from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import Images from 'config/assets';

import styles from './styles';

const UserWithoutAccounts = () => (
  <div style={styles.container}>
    <UTLabel bold style={styles.label}>
      {message('ErrorScreen:userWithoutAccounts')}
    </UTLabel>
    <img alt="" src={Images.withoutAccountsAvatar} style={styles.avatar} />
  </div>
);

export default Radium(UserWithoutAccounts);
